import { IStrategy, TTickerCurrency } from '../../../types/model';
import { getSymbol, getTotalValues } from '../../../helpers/functions';
import { CustomNumber } from '../../CustomNumber/CustomNumber';
import { Icon } from '../../UI';
import { ProfitLoss } from '../../ProfitLoss';
import { StrategyProgressBar } from './ProgressBar/StrategyProgressBar';

import { t } from 'i18next';

function PriceTargetsHeader({
  className = 'flex flex-col w-full pl-5',
  strategy: {
    strategyAssets: { items },
    currency,
    createdAt,
  },
  width,
}: {
  className?: string;
  strategy: IStrategy;
  width: number;
}) {
  const { percent, totalEntryValue, totalValue } = getTotalValues(
    items,
    currency.toLocaleLowerCase() as TTickerCurrency,
    createdAt
  );

  const strategyMarkers = items.reduce(
    (obj, { unit, strategyAssetTargets: { items } }) =>
      items.length
        ? {
            ...obj,
            stopLoss: obj.stopLoss + items[0].stopLoss * unit,
            stopProfit: obj.stopProfit + items[0].stopProfit * unit,
          }
        : obj,
    { stopLoss: 0, stopProfit: 0 }
  );

  return (
    <div className={className}>
      {/* Header body */}
      <div
        className={`
          grid
          ${width >= 3 ? 'grid-cols-6' : 'grid-cols-3'}
          gap-x-5
          my-3
        `}
      >
        {/* Invested */}
        <div className="">
          <div className="font-normal text-grey-70 dark:text-white text-sm">
            {t('assetsProgress.invested')}
          </div>

          <CustomNumber
            className={`font-semibold text-${width === 1 ? 'md' : 'lg'}`}
            suffix={getSymbol(currency)}
            value={totalEntryValue}
          />
        </div>

        {/* Total Value */}
        <div className="">
          <div className="font-normal text-grey-70 dark:text-white text-sm">
            {t('assetsProgress.total')}
          </div>

          <CustomNumber
            className={`font-semibold text-${width === 1 ? 'md' : 'lg'}`}
            suffix={getSymbol(currency)}
            value={totalValue}
          />
        </div>

        <div className="">
          <div className="font-normal text-grey-70 dark:text-white text-sm">
            {t('assetsProgress.performance')}
          </div>
          <ProfitLoss
            percentage={percent}
            symbol={getSymbol(currency)}
            value={totalValue - totalEntryValue}
          />
        </div>

        <div
          className={`
            ${width < 3 && 'py-3'}
            col-span-3
            w-full
            justify-self-end
            flex
            flex-col
            justify-between
            h-full
          `}
        >
          <div className="font-normal text-grey-70 dark:text-white text-xs">
            {t('assetsProgress.strategy')}
          </div>
          <div
            className={`
              h-full
              flex
              items-center
              mr-2
              ${width !== 3 && 'mt-4'}
            `}
          >
            <StrategyProgressBar
              lastPrice={totalValue}
              entryPrice={totalEntryValue}
              currency={currency}
              markers={[strategyMarkers]}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PriceTargetsHeader;
